module.exports = __webpack_public_path__ + "img/UTS-Icon6_os.8686b00c.png";